export enum RedirectType {
    Home = 0,
    Registration = 1,
    Login = 2
}